import { render } from "./CallbackView.vue?vue&type=template&id=b4219278&scoped=true"
import script from "./CallbackView.vue?vue&type=script&lang=js"
export * from "./CallbackView.vue?vue&type=script&lang=js"

import "./CallbackView.vue?vue&type=style&index=0&id=b4219278&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4219278"]])

export default __exports__